module.exports = __webpack_public_path__ + "media/images/log/log-count-04b360b98674d31b8b5b31a0fedf4d82.svg";